<div #seDateTimePickerDiv class="se-datetime-picker-main-container" [class.se-datetime-no-highlight]="!highlightBackgroundEnabled">
    <mat-form-field class="se-form-field"
                    [floatLabel]="isWithLabel ? 'always' : 'auto'"
                    appearance="outline">
        <mat-label *ngIf="isWithLabel">{{ label }}</mat-label>
        <input #dateInput
               matInput
               class="se-form-field-input"
               autocomplete="off"
               [matDatepicker]="seDateTimePicker_Date"
               [(ngModel)]="defaultDate"
               [placeholder]="datePlaceholder"
               (dateChange)="onDateChanging($event)"
               [disabled]="disabled"
               (keydown)="onDateTimeKeydown($event)"
               [errorStateMatcher]="dateTimePickerMatcher"
               [required]="required" />
        <mat-datepicker-toggle class="se-button-no-ripple" tabindex="-1" [for]="seDateTimePicker_Date" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #seDateTimePicker_Date [panelClass]="customPanelClass"></mat-datepicker>
        <mat-error *ngIf="isOnError">{{ getErrorMessage() }}</mat-error>
        <mat-hint class="se-datetime-picker-hint" *ngIf="!isOnError && showDateFormatOnHint">{{getDateFormat()}}</mat-hint>
    </mat-form-field>

    <ngx-timepicker-field #seTimePickerInput
                          [disabled]="disabled"
                          (timeChanged)="onTimeChanging($event)"
                          class="se-datetime-picker-time-picker"
                          [class.se-datetime-picker-time-picker-error]="isOnError"
                          placeholder="data"
                          [controlOnly]="true"
                          [(ngModel)]="defaultTime"
                          [format]="clockAmPm">
    </ngx-timepicker-field>

    <button mat-icon-button
            class="se-datetime-picker-reset-button se-button-no-ripple"
            matSuffix
            type="button"
            tabIndex="-1"
            (click)="onResetDateTime()"
            *ngIf="showResetButton && !disabled">
        <mat-icon>close</mat-icon>
    </button>
</div>
